<template>
    <div class="datetime-com">
        <el-date-picker v-if="!validate" v-model="value" :size="size" :align="align" :default-time="defaultTime"
            :type="type" :picker-options="pickerOptions" :placeholder="placeholder" :value-format="valueFormat"
            :disabled="disabled" @change="handleDateChanged">
        </el-date-picker>
        <el-form :model="form" :rules="rule" ref="form" v-else>
            <el-form-item prop="value">
                <el-date-picker v-model="form.value" :size="size" :align="align" :default-time="defaultTime"
                    :type="type" :picker-options="pickerOptions" :placeholder="placeholder" :value-format="valueFormat"
                    @change="handleDateChanged">
                </el-date-picker>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    name: 'DatetimeCom',
    props: {
        type: {
            type: String,
            default: 'datetime'
        },
        placeholder: {
            type: String,
            default: '选择日期时间'
        },
        // 对齐方式
        align: {
            type: String,
            default: 'left'
        },
        pickerOptions: {
            type: Object
        },
        defaultTime: {
            type: String
        },
        valueFormat: {
            type: String,
            default: 'yyyy-MM-dd HH:mm:ss'
        },
        size: {
            type: String,
            default: 'mini'
        },
        validate: {
            type: Boolean,
            default: false
        },
        rules: {
            type: Array,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showValue: {
            type: String
        }
    },
    data() {
        return {
            value: '',
            form: {
                value: ''
            },
            rule: {
                value: this.rules
            }
        }
    },
    methods: {
        handleDateChanged(val) {
            this.$emit('handleDateChanged', val)
        }
    },
    watch: {
        showValue: {
            handler(n){
                if (this.validate) {
                    this.form.value = n
                } else {
                    this.value = n
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/DatetimeCom.vue